import { makeObservable, observable, computed } from "mobx";
import { ImCampaign, ImCampaignStatus, ImCampaignStats } from "@whatslly/types/tuvis-messaging/TuvisMessagingCampaign";

export class IMCampaign implements ImCampaign {
  _id: string;
  orgId: string;
  status: ImCampaignStatus;
  phoneNumberId: string;
  senderPhoneNumber: string;
  templateName: string;
  templateLanguage: string;
  templateComponents: unknown[];
  createdBy: string;
  totalCount?: number;
  completedCount?: number;
  failedCount?: number;
  createdAt: string;
  updatedAt: string;

  constructor(data: ImCampaign) {
    this._id = data._id;
    this.orgId = data.orgId;
    this.status = data.status;
    this.phoneNumberId = data.phoneNumberId;
    this.senderPhoneNumber = data.senderPhoneNumber;
    this.templateName = data.templateName;
    this.templateLanguage = data.templateLanguage;
    this.templateComponents = data.templateComponents;
    this.totalCount = data.totalCount;
    this.completedCount = data.completedCount;
    this.failedCount = data.failedCount;
    this.createdBy = data.createdBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;

    makeObservable(this, {
      status: observable,
      totalCount: observable,
      completedCount: observable,
      failedCount: observable,
      updatedAt: observable,
      stats: computed,
    });
  }

  get stats(): ImCampaignStats {
    const total = this.totalCount ?? 0;
    const completed = this.completedCount ?? 0;
    const failed = this.failedCount ?? 0;
    const pending = Math.max(0, total - completed - failed);
    return { total, pending, completed, failed };
  }
}
